export interface ContextHelpEntry {
  title: string;
  articleIds: string[];
}

const contextHelpConfig: Record<string, ContextHelpEntry> = {
  dashboard: {
    title: 'Dashboard Help',
    articleIds: ['dashboard-overview', 'understanding-mms-entities', 'user-journeys-overview', 'tenant-features-modules'],
  },
  inventory: {
    title: 'Inventory Help',
    articleIds: ['add-raw-material', 'manage-products', 'wastage-tracking', 'inventory-batch-management'],
  },
  factory: {
    title: 'Factory Floor Help — use the Quality Checks tab for inspection lots',
    articleIds: ['factory-floor-overview', 'create-batch', 'processing-runs', 'inventory-batch-management'],
  },
  orders: {
    title: 'Orders Help',
    articleIds: ['create-order', 'track-orders', 'inbound-vendor-orders'],
  },
  workforce: {
    title: 'Workforce Help',
    articleIds: ['add-worker', 'manage-assignments', 'workforce-attendance'],
  },
  assets: {
    title: 'Assets Help',
    articleIds: ['register-asset', 'schedule-maintenance'],
  },
  finance: {
    title: 'Finance Help',
    articleIds: ['create-bill', 'manage-payments', 'revenue-report', 'expense-report'],
  },
  reports: {
    title: 'Reports Help',
    articleIds: ['stock-inventory-reports', 'order-summary-report', 'production-batch-report', 'tax-gst-report'],
  },
  approvals: {
    title: 'Approvals Help',
    articleIds: ['setup-rules', 'manage-notifications'],
  },
  notifications: {
    title: 'Notifications Help',
    articleIds: ['manage-notifications', 'setup-rules'],
  },
};

export default contextHelpConfig;
